var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgConnector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,60.29A31.89,31.89,0,0,1,10.75,4.52l.64-.58,1.13-.23H52.38l.66.61a31.9,31.9,0,0,1-21,56ZM14.11,10.05a25.66,25.66,0,1,0,35.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.65,6.48H12.78L3.33,21.29,6.42,42.64l10,12.65H32.08l21.38-4L60.1,23ZM40.68,14a3.41,3.41,0,1,1-3.41,3.41A3.4,3.4,0,0,1,40.68,14ZM24.91,14a3.41,3.41,0,1,1-3.41,3.41A3.4,3.4,0,0,1,24.91,14ZM11,28.44a5.42,5.42,0,1,1,5.42,5.41A5.42,5.42,0,0,1,11,28.44ZM24.48,47a5.41,5.41,0,1,1,5.42-5.41A5.42,5.42,0,0,1,24.48,47ZM27,28.44a5.08,5.08,0,1,1,5.08,5.08A5.08,5.08,0,0,1,27,28.44ZM40.68,47a5.41,5.41,0,1,1,5.41-5.41A5.42,5.42,0,0,1,40.68,47Zm7.37-13.17a5.41,5.41,0,1,1,5.41-5.41A5.41,5.41,0,0,1,48.05,33.85Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28.59,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.31,
    cy: 28.59,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.6,
    cy: 41.76,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 41.76,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.97,
    cy: 28.59,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.82,
    cy: 17.57,
    r: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.6,
    cy: 17.57,
    r: 1.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,56.51A27.91,27.91,0,0,1,13.4,7.7l.24-.21H50.36l.24.21A27.91,27.91,0,0,1,32,56.51ZM14.29,9.19a26.31,26.31,0,1,0,35.42,0Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConnector2);
export default __webpack_public_path__ + "static/media/img_connector_2.0cfbd80e84be48b6dfd90c296699b908.svg";
export { ForwardRef as ReactComponent };